import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../services/login";
import { clearLocalStorageExcept, userAccessToken } from "../helpers";

const useSessionTimeout = () => {
  const navigate = useNavigate();

  const logoutFunction = async () => {
    try {
      await logout();
      await clearLocalStorageExcept();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Failed to logout", error);
    }
  };

  useEffect(() => {
    const checkSession = async () => {
      try {
        
        const accessToken = userAccessToken();
        if (!accessToken) {
          await logoutFunction();
        }
  
        const { exp } = JSON.parse(atob(accessToken.split(".")[1])); // Decode JWT payload
        const expDate = new Date(exp * 1000); // Convert to milliseconds
        const now = new Date();
  
        if (now > expDate) {
          await logoutFunction();
        }
      } catch (error) {
        await logoutFunction();
      };
  
      checkSession();
        
      }
  }, [navigate]);

  return null;
};

export default useSessionTimeout;
